import React from 'react';
import styled from 'styled-components';
import {
  SectionParent,
  H1,
  H2,
  H3,
  BlueButton,
} from '../../components/StyledComponents';
import remote from '../../assets/v2/Hardware/remote.svg';
import compatibility from '../../assets/v2/Hardware/compatibility.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import kiosk from '../../assets/v2/Hardware/kiosk-mode.svg';
import OS from '../../assets/v2/Hardware/OS.svg';

import custom from '../../assets/v2/Hardware/custom-enhanced.svg';
import deploy from '../../assets/v2/Hardware/deploy-enhanced.svg';
import secure from '../../assets/v2/Hardware/secure-enhanced.svg';
import date from '../../assets/v2/Hardware/date-enhanced.svg';

const Section = styled(SectionParent)`
  display: grid;
  justify-items: center;
  width: 100%;
  padding-bottom: 2rem !important;
  background: #ffffff;
  @media (max-width: 520px) {
    padding-bottom: 0 !important;
  }
`;
const SectionTitle = styled(H1)`
  padding-top: 3rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a5376;
  margin-bottom: 2rem;
  @media (max-width: 520px) {
    padding-top: 1rem;
    margin-bottom: 1rem;
    width: 80%;
  }
`;
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  /* padding-top: 2rem; */
  /* padding-bottom: 3rem; */
  /* flex-wrap: wrap; */
  width: 100%;
  margin-right: -3rem;
  margin-left: -3rem;
  justify-content: center;
  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    padding-top: 0rem;
    padding-bottom: 0rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 1;
  padding: 2rem;
  padding-top: 1rem;
  min-width: 250px;
  background: #ffffff;
  @media (max-width: 768px) {
    padding-top: 4rem;
    flex: 0 0 calc(100%);
    padding-right: 10%;
    padding-left: 10%;
    display: grid;
    justify-items: center;
  }
  @media (max-width: 520px) {
    min-width: unset;
    padding-top: 0;
  }
`;

const GridItemTitle = styled(H2)`
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  width: 100%;
  color: #4a5376;

  padding-bottom: 10px;
  min-height: 2rem;
  margin-top: 1rem;
  @media (max-width: 768px) {
    min-height: 0;
  }
  @media (max-width: 520px) {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    text-align: center;
  }
`;

const GridItemDescription = styled.div`
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  font-size: 16px;
  font-family: 'Nunito Sans', sans-serif;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #7f8495;
  @media (max-width: 520px) {
    text-align: center;
    font-size: 14px;
  }
`;

const imageStyle = {
  height: 'fit-content',
  width: 'fit-content',
};

const ImgContainer = styled.div`
  display: grid;
  justify-self: left;
  @media (max-width: 520px) {
    justify-self: center;
  }
`;
export default class SectionThree extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }
  state = {
    posts: [],
  };
  render() {
    return (
      <div>
        <Section>
          <SectionTitle>
            {this.props.enhanced ? (
              <span style={{ color: '#725cbd' }}>
                Features Of Esper Enhanced Android Devices
              </span>
            ) : (
              'Features Of Esper Validated Android Devices'
            )}
          </SectionTitle>
          <GridContainer>
            <GridItem>
              <ImgContainer>
                <LazyLoadImage
                  src={this.props.enhanced ? custom : compatibility}
                  alt="Customizable Android OS"
                  style={imageStyle}
                />
              </ImgContainer>
              <GridItemTitle>
                {this.props.enhanced ? (
                  'CUSTOMIZABLE ANDROID OS'
                ) : (
                  <span>
                    Application and Device <br />
                    Compatibility
                  </span>
                )}
              </GridItemTitle>
              <GridItemDescription>
                {this.props.enhanced
                  ? 'Get exactly the Android OS image needed for your use case, including in-ROM apps. No more bloatware using up storage, processing, and data.'
                  : 'Improve the interoperability of hardware, OS, and applications.'}
              </GridItemDescription>
            </GridItem>
            <GridItem>
              <ImgContainer>
                <LazyLoadImage
                  alt="Easy Deployment"
                  src={this.props.enhanced ? deploy : OS}
                  style={imageStyle}
                />
              </ImgContainer>
              <GridItemTitle>
                {this.props.enhanced ? (
                  'EASY DEPLOYMENT'
                ) : (
                  <span>
                    Managed OS
                    <br />
                    Updates
                  </span>
                )}
              </GridItemTitle>
              <GridItemDescription>
                {this.props.enhanced
                  ? 'Zero-touch provisioning, secure remote debugging, ready-to-go remote control and view. Reduce unneeded travel for SEs and devs.'
                  : ' Predictable, quarterly updates to improve security and performance..'}
              </GridItemDescription>
            </GridItem>
            <GridItem>
              <ImgContainer>
                <LazyLoadImage
                  alt="Wide Device Selection"
                  src={this.props.enhanced ? secure : kiosk}
                  style={imageStyle}
                />
              </ImgContainer>
              <GridItemTitle>
                {this.props.enhanced ? (
                  'WIDE DEVICE SELECTION'
                ) : (
                  <span>
                    Secure <br />
                    Kiosk Mode
                  </span>
                )}
              </GridItemTitle>
              <GridItemDescription>
                {this.props.enhanced
                  ? 'We offer a wide variety of devices with various form factors such as phones, tablets, POS, Kiosks, and more.'
                  : 'Deploy single or multi-app kiosk mode devices and experiences.'}
              </GridItemDescription>
            </GridItem>
            <GridItem>
              <ImgContainer>
                <LazyLoadImage
                  alt="Always Up-to-Date"
                  src={this.props.enhanced ? date : remote}
                  style={imageStyle}
                />
              </ImgContainer>
              <GridItemTitle>
                {this.props.enhanced ? (
                  'ALWAYS UP-TO-DATE'
                ) : (
                  <span>
                    Remote Control <br />
                    and Debugging
                  </span>
                )}
              </GridItemTitle>
              <GridItemDescription>
                {this.props.enhanced
                  ? 'No more waiting for late updates and patches for your device fleet - we take care of it.'
                  : 'View and remotely remediate devices in production.'}
              </GridItemDescription>
            </GridItem>
          </GridContainer>
        </Section>
      </div>
    );
  }
}
